/**
 * captureComposerContext — which composer tab the (+) button should open on.
 *
 * WHY THIS FILE EXISTS (Osama, QA-101, 2026-08-04)
 * "the Capture (+) button inside a category should keep that category's context
 * (from Photos, open the Photo capture flow), not redirect to Notes."
 *
 * Web has no per-category ROUTE — the categories are the toolbar's filter chips
 * on one page — so the web leg of QA-101 is exactly this: the composer inherits
 * the chip the user is standing on. (The mobile leg, "back from a category
 * returns to the previous category", is a React Native navigation-stack change
 * and is NOT in this module's reach; it is called out in the PR body.)
 *
 * PRECEDENCE, and why it is this way round
 * The active chip beats the CAP-4 "last type you picked" memory: the chip is a
 * thing the user is looking at RIGHT NOW, the memory is from some previous
 * session. With no chip active (the All filter) the memory still wins, so CAP-4
 * is preserved rather than quietly reverted.
 */

import {
  CAPTURE_TYPES,
  FILTER_ALL,
  getLastCaptureType,
} from "./Capture.helpers";

/** Types the composer actually has a tab for. */
const COMPOSER_TYPES = [
  CAPTURE_TYPES.TEXT,
  CAPTURE_TYPES.PHOTO,
  CAPTURE_TYPES.VIDEO,
  CAPTURE_TYPES.AUDIO,
  CAPTURE_TYPES.DOC,
  CAPTURE_TYPES.LINK,
];

/**
 * @param {string} filterType the active toolbar chip
 * @param {function} [readLastType] injectable for tests; defaults to the CAP-4
 *   localStorage memory.
 * @returns {string} a CAPTURE_TYPES value the composer can open on
 */
export const composerTypeForFilter = (filterType, readLastType = getLastCaptureType) => {
  if (filterType && filterType !== FILTER_ALL && COMPOSER_TYPES.includes(filterType)) {
    return filterType;
  }
  return readLastType();
};
